import {useAppSelector} from '@app/redux/reduxHooks';
import {userSelector} from '@app/redux/slices/userSlice';

import {TUser} from '@app/types';

export const useUser = (): TUser | undefined => useAppSelector(userSelector);
